(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["braody-footer"]) return;
  try {
    
(() => {
  if (window.Shopify && window.Shopify.designMode) return;

  const form = document.getElementById('BraodyFooterNewsletter');
  if (!form) return;

  const storageKey = 'braody-footer-newsletter-engaged';
  const suppressPopup = () => {
    const popup = document.querySelector('newsletter-popup');
    if (!popup) return;
    if (popup.hasAttribute('open')) {
      popup.querySelector('.pop-in__close-button')?.click();
    }
    popup.remove();
  };
  const markEngaged = () => {
    try {
      sessionStorage.setItem(storageKey, '1');
    } catch (error) {}
    suppressPopup();
  };
  try {
    if (sessionStorage.getItem(storageKey) === '1') suppressPopup();
  } catch (error) {}

  form.addEventListener('focusin', markEngaged);
  form.addEventListener('input', markEngaged);
  form.addEventListener('submit', markEngaged);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["braody-gift-guide"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-braody-gift-guide]').forEach(function(root){
  if(root.dataset.initialized==='true') return;
  root.dataset.initialized='true';
  var step=1;
  var answers={};
  var steps=root.querySelectorAll('[data-bg-step]');
  var next=root.querySelector('[data-bg-next]');
  var back=root.querySelector('[data-bg-back]');
  var actions=root.querySelector('[data-bg-actions]');
  var results=root.querySelector('[data-bg-results]');
  var addAll=root.querySelector('[data-bg-add-all]');
  var cartArea=root.querySelector('[data-bg-cart-area]');
  var cartStatus=root.querySelector('[data-bg-cart-status]');
  var selectedPicks=[];
  var bar=root.querySelector('[data-bg-progress-bar]');
  var label=root.querySelector('[data-bg-progress-label]');
  var catalog=Array.from(root.querySelectorAll('[data-bg-product]')).map(function(el){
    var p={title:el.dataset.title,handle:el.dataset.handle,kind:el.dataset.kind,tags:el.dataset.tags,price:Number(el.dataset.price),available:el.dataset.available==='true',variantId:el.dataset.variantId,url:el.dataset.url,image:el.dataset.image||''};
    var text=[p.title,p.kind,p.tags].join(' ').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    p.group=/bruleur/.test(text)?'bruleur':/fondant/.test(text)?'fondant':/bougie/.test(text)?'bougie':/spray/.test(text)?'spray':/plateau|decor|figurine|champignon|renne|boule/.test(text)?'deco':/coupe.?meche/.test(text)?'accessoire':'autre';
    return p;
  }).filter(function(p){return p.group!=='autre'&&p.price>0});
  function show(n){
    step=n;
    steps.forEach(function(el){el.hidden=Number(el.dataset.bgStep)!==n});
    results.hidden=n!==5;
    actions.hidden=n===5;
    label.textContent=n===5?'VOTRE SÉLECTION':'QUESTION '+String(n).padStart(2,'0')+' / 04';
    bar.style.width=(Math.min(n,4)/4*100)+'%';
    back.hidden=n===1;
    next.disabled=n<=4?!answers[['recipient','occasion','budget','style'][n-1]]:true;
    next.innerHTML=n===4?'DÉCOUVRIR MES IDÉES CADEAUX <span aria-hidden="true">→</span>':'CONTINUER <span aria-hidden="true">→</span>';
  }
  root.querySelectorAll('[data-bg-answer]').forEach(function(button){
    button.setAttribute('aria-pressed','false');
    button.addEventListener('click',function(){
      var key=button.dataset.bgAnswer;
      answers[key]=button.dataset.bgValue;
      root.querySelectorAll('[data-bg-answer="'+key+'"]').forEach(function(b){b.setAttribute('aria-pressed',b===button?'true':'false')});
      next.disabled=false;
    });
  });
  function score(p){
    var s=0;
    var style=answers.style;
    if(style==='cocon') s+=({bougie:12,fondant:9,bruleur:7,spray:4,deco:3,accessoire:2})[p.group]||0;
    if(style==='parfum') s+=({fondant:13,bruleur:10,spray:9,bougie:8,deco:1,accessoire:1})[p.group]||0;
    if(style==='deco') s+=({deco:14,bruleur:12,bougie:6,spray:2,fondant:2,accessoire:1})[p.group]||0;
    if(style==='surprise') s+=({bougie:9,bruleur:9,fondant:8,deco:8,spray:6,accessoire:2})[p.group]||0;
    if(answers.recipient==='maman'&&p.group==='bougie') s+=4;
    if(answers.recipient==='amie'&&p.group==='fondant') s+=3;
    if(answers.recipient==='proche'&&p.group==='deco') s+=3;
    if(answers.recipient==='moi'&&p.group==='spray') s+=3;
    if(answers.occasion==='noel'&&/noel|boule|renne/.test(p.title.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase())) s+=6;
    if(answers.occasion==='merci'&&p.group==='bougie') s+=2;
    if(p.available) s+=1;
    if(p.image) s+=16;
    return s;
  }
  function euros(cents){return (cents/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'})}
  function createCard(p){
    var card=document.createElement('article');card.className='bgift__product';
    var photo=document.createElement('div');photo.className='bgift__photo';
     var photoKind=(p.title+' '+p.kind).toLocaleLowerCase();
     if(/spray|brume/.test(photoKind))photo.classList.add('bgift__photo--spray');
     else if(/bougie/.test(photoKind))photo.classList.add('bgift__photo--bougie');
    if(p.image){var img=document.createElement('img');img.src=p.image;img.alt=p.title;img.loading='lazy';photo.appendChild(img)}
    else{var symbol=document.createElement('span');symbol.className='bgift__fallback';symbol.textContent='✧';photo.appendChild(symbol)}
    if(!p.available){var sold=document.createElement('span');sold.className='bgift__soldout';sold.textContent='ACTUELLEMENT ÉPUISÉ';photo.appendChild(sold)}
    card.appendChild(photo);
    var info=document.createElement('div');info.className='bgift__product-info';
    var small=document.createElement('div');small.className='bgift__product-label';small.textContent='UNE IDÉE CADEAU';
    var name=document.createElement('h3');name.className='bgift__product-title';name.textContent=p.title;
    var price=document.createElement('p');price.className='bgift__product-price';price.textContent=euros(p.price);
    var link=document.createElement('a');link.className='bgift__product-link';link.href=p.url;link.textContent='Découvrir la création';
    info.appendChild(small);info.appendChild(name);info.appendChild(price);info.appendChild(link);card.appendChild(info);
    return card;
  }
  function render(){
    var target=root.querySelector('[data-bg-products]');target.replaceChildren();
    var min=answers.budget==='grand'?6000:0;
    var max=answers.budget==='petit'?1500:answers.budget==='moyen'?3500:answers.budget==='beau'?6000:Infinity;
    var pool=catalog.filter(function(p){return p.price<=max&&p.price>0});
    if(answers.budget==='moyen') pool=pool.filter(function(p){return p.price>=1500});
    if(answers.budget==='beau') pool=pool.filter(function(p){return p.price>=3500});
    pool.sort(function(a,b){return score(b)-score(a)});
    var picks=[];
    if(answers.budget==='grand'){
      var ranked=catalog.slice().sort(function(a,b){return score(b)-score(a)});
      var first=ranked.find(function(p){return p.price>=3000&&p.group!=='accessoire'})||ranked[0];
      if(first) picks.push(first);
      var second=ranked.find(function(p){return first&&p.handle!==first.handle&&p.group!==first.group&&p.price+first.price>=min});
      if(!second) second=ranked.find(function(p){return first&&p.handle!==first.handle&&p.group!==first.group});
      if(second) picks.push(second);
    }else{picks=pool.slice(0,2)}
    if(!picks.length){picks=catalog.slice().sort(function(a,b){return score(b)-score(a)}).slice(0,2)}
    picks.forEach(function(p){target.appendChild(createCard(p))});
    selectedPicks=picks;
    cartArea.hidden=!picks.length;
    var complete=picks.length>0&&picks.every(function(p){return p.available&&p.variantId});
    addAll.disabled=!complete;
    addAll.textContent='AJOUTER LA SÉLECTION AU PANIER · '+euros(picks.reduce(function(t,p){return t+p.price},0));
    cartStatus.textContent=complete?'Toutes les créations seront ajoutées ensemble au panier.':'Une ou plusieurs créations sont épuisées. Elles restent visibles, mais la sélection complète ne peut pas être ajoutée pour le moment.';
    var intro=root.querySelector('[data-bg-result-intro]');
    if(answers.budget==='grand'&&picks.length===2){intro.textContent='Deux créations à associer pour un cadeau unique.'}
    else if(picks.length){intro.textContent=answers.recipient==='moi'?'Voici les créations que nous avons sélectionnées pour vous faire plaisir.':'Voici une sélection de créations BRAODY adaptée à votre budget et à ses envies.'}
    else{intro.textContent='Les nouvelles créations BRAODY apparaîtront ici dès leur mise en ligne.'}
    show(5);
  }
  addAll.addEventListener('click',async function(){
    if(addAll.disabled||!selectedPicks.length)return;
    addAll.disabled=true;
    addAll.textContent='AJOUT EN COURS…';
    cartStatus.textContent='';
    try{
      var rootPath=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
      var response=await fetch(rootPath+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:selectedPicks.map(function(p){return{id:Number(p.variantId),quantity:1}})})});
      if(!response.ok){var failure=await response.json().catch(function(){return{}});throw new Error(failure.description||'Impossible d’ajouter cette sélection au panier.')}
      window.location.assign(rootPath+'cart');
    }catch(err){
      cartStatus.textContent=err.message||'Une erreur est survenue. Merci de réessayer.';
      addAll.disabled=false;
      addAll.textContent='RÉESSAYER D’AJOUTER LA SÉLECTION';
    }
  });
  next.addEventListener('click',function(){if(next.disabled)return;if(step===4)render();else show(step+1)});
  back.addEventListener('click',function(){if(step>1)show(step-1)});
  root.querySelector('[data-bg-restart]').addEventListener('click',function(){
    answers={};
    root.querySelectorAll('[data-bg-answer]').forEach(function(b){b.setAttribute('aria-pressed','false')});
    show(1);
    root.scrollIntoView({behavior:'smooth',block:'start'});
  });
  show(1);
});

  } catch(e) { console.error(e); }
})();
})();
